import { addTokenInUrl, getAwsAssets } from "@src/utils";
import styles from "./StandAlone.module.scss";
// import Lottie from "react-lottie";
import standAloneLotie from "@src/utils/DoubtBuddyF.json";
import Button from "@src/components/UIElements/Button";
import { useSelector } from "react-redux";
import { hitContentDeeplinkOld } from "../../../Content/helpers/hitContentDeeplink";
import doubtBuddyGif from "@src/assets/doubtbuddy.gif";

function StandAlone() {
  const imageCard = [
    getAwsAssets("standAloneAllSubject.jpeg", "content"),
    getAwsAssets("standAloneCrop26.jpeg", "content"),
    getAwsAssets("standAloneSuperFast.jpeg", "content"),
    getAwsAssets("yourDoubt26.jpeg", "content"),
  ];
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: standAloneLotie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const token = useSelector((state) => state?.persistedDataReducer?.userToken);
  const isPurchased = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.isPurchased) || false;
    const  standAloneUrl = useSelector(
      (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.doubtBuddyUrl) || false;
      const handleStandAlone = () => {
        if(standAloneUrl) {
          hitContentDeeplinkOld("UTIL_WEBVIEW", {paramOne: standAloneUrl}, true, true)
        }
      }
  return (
    <div className={styles.StandAlone}>
      <div className={styles.StandAlone__IntroduncingDoubtMate}>
        <img
          src={doubtBuddyGif}
          alt="DoubtBuddy animation"
          style={{ borderRadius: "12px", width: "100%", height: "auto" }}
        />
      </div>
      <div className={styles.StandAlone__about}>
        <p className={styles.StandAlone__about__heading}>About Doubt Mate</p>
        <p className={styles.StandAlone__about__subHeading}>
          Click Photo, Get Answer{" "}
        </p>
        <p className={styles.StandAlone__about__description}>
          A one of it’s kind friend that will give you superfast solutions to
          all your doubts with quality explanation in 60 sec. Just click a photo
          of the question, upload, and wait for the solution to pop up.
        </p>
        <div className={styles.StandAlone__about__imgDiv}>
          {imageCard.map((items, index) => {
            return <img key={index} src={items} alt="" height={200} />;
          })}
        </div>
        {isPurchased === 1 ? (
        <div className={styles.contentDdiv}>
          <p>DoubtBuddy</p>
          <div className={styles.doubtExtra}>
            <p className={styles.descp}>
              Get superfast solution to your doubts with explanation in 60 sec.
            </p>
            <Button className={styles.viewALLBtn} onClick={handleStandAlone}>
              Let&apos;s try now &rarr;
            </Button>
          </div>
        </div>) : null}
      </div>
    </div>
  );
}
export default StandAlone;
